<template>
  <div :class="{ inline: option.inline }">
    <div class="title-titleText" v-html="label" />
    <div class="ml-1 text-primary" style="white-space: pre-line;">
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
    }
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        this.data = e
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.inline {
  display: flex;
}
.title-titleText {
  color: var(--Color-Text-text-color-primary, #303133);
  /* bold/base */
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 157.143% */
}
</style>
